<template>
  <v-layout class="grey lighten-4 pa-3" column>
    <v-alert dense prominent text type="info">
      <span>Estimado restaurante: Ya se encuentra disponible la nueva versión de EATO, te invitamos a registrate. <a href="https://auth.eato.mx/" target="_blank">haz click aquí</a></span>
    </v-alert>
    <div v-if="tabs.length > 1">
      <v-tabs
        v-model="activeTab"
        grow>

        <v-tab v-for="(tab, index) in tabs" :key="`tab-${index}`" :to="{ name: tab.name }">
          {{ $t(tab.tabMenu) }}
        </v-tab>
      </v-tabs>

      <v-tabs-items
        v-model="activeTab"
        touchless>
        <v-tab-item
          :transition="false"
          :reverse-transition="false"
          class="grey lighten-4"
          v-for="(tab, index) in tabs"
          :key="`item-${index}`"
          :value="tab.route">
          <div v-if="tab.route === activeTab">
            <router-view />
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <div v-else>
      <router-view />
    </div>
  </v-layout>
</template>

<script>
export default {
  name: 'RecipeBook',
  data () {
    return {
      activeTab: null
    }
  },
  computed: {
    tabs () {
      const tabs = [
        { tabMenu: 'menu.kitchen.recipes', name: 'Recipes', route: `/recipes-book/recipes`, roles: ['manager', 'chef'] },
        { tabMenu: 'menu.kitchen.subrecipes', name: 'Subrecipes', route: `/recipes-book/subrecipes`, roles: ['manager', 'chef'] },
        { tabMenu: 'menu.kitchen.combos', name: 'ComboList', route: `/recipes-book/combos`, roles: ['manager', 'chef'] },
        { tabMenu: 'menu.kitchen.menu', name: 'MenuByArea', route: `/recipes-book/by-area`, roles: ['manager', 'chef'] }
      ]
      return tabs.filter(tab => tab.roles.includes(this.$is()))
    }
  }
}
</script>
